<template>
  <div class="wrapper container is-fluid">
    <div
      class="backdrop"
      :class="{ 'active-backdrop': menuActive }"
      @click="closeMenu"
    ></div>
    <SidebarMenu></SidebarMenu>
    <AlertMessage :alert="alert" v-if="alert.isAlert"></AlertMessage>
    <div class="wrapper__content" :class="{ 'is-loading': loading }">
      <HeaderMenu></HeaderMenu>
      <main class="main">
        <transition name="fade">
          <Loading v-if="loading"></Loading>
        </transition>
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import SidebarMenu from "@/components/SidebarMenu";
import HeaderMenu from "@/components/HeaderMenu";
import AlertMessage from "@/components/base/AlertMessage";
import Loading from "@/components/Loading";
import { ROLES } from "@/utils/constants";

export default {
  name: "Layout",
  components: {
    SidebarMenu,
    HeaderMenu,
    AlertMessage,
    Loading
  },
  computed: {
    ...mapState("settings", ["loading", "alert", "menuActive"])
  },
  mounted() {
    const roles = JSON.parse(localStorage.getItem("roles"));
    this.SET_ROLES(roles);

    const currentRole = this.$localStorage.get("current_role");
    if (currentRole) {
      this.SET_CURRENT_ROLE(currentRole);
    }
    const currentSubRole = this.$localStorage.get("current_sub_role");
    if (currentSubRole) {
      this.SET_CURRENT_SUB_ROLE(currentSubRole);
    }

    // obtener path de url
    const path = this.$route.path;
    const rolGroup = path.split("/")[1];
    const formatRoles = {
      empresa: ROLES.COMPANY_GROUP,
      puntos: ROLES.COMPANY_POINT,
      regalos: ROLES.CLIENT_CODE,
      recompensa: ROLES.RECOMPENSA,
      validador: ROLES.SERVICE_USER
    };

    if (
      !roles ||
      roles.length === 0 ||
      !roles.includes(formatRoles[rolGroup])
    ) {
      this.$router.push({ name: "not-allowed" }).catch(() => {});
    }

    if (rolGroup === "puntos") {
      this.SET_CURRENT_ROLE(ROLES.COMPANY_GROUP);
      this.SET_CURRENT_SUB_ROLE(ROLES.COMPANY_POINT);
    } else if (rolGroup === "validador") {
      this.SET_CURRENT_ROLE(ROLES.SERVICE_USER);
    } else if (rolGroup === "regalos") {
      this.SET_CURRENT_ROLE(ROLES.COMPANY_GROUP);
      this.SET_CURRENT_SUB_ROLE(ROLES.CLIENT_CODE);
    } else if (rolGroup === "recompensa") {
      this.SET_CURRENT_ROLE(ROLES.RECOMPENSA);
    } else {
      this.$router.push({ name: "not-allowed" }).catch(() => {});
    }
  },
  methods: {
    ...mapMutations("settings", [
      "SET_ROLES",
      "SET_CURRENT_ROLE",
      "SET_CURRENT_SUB_ROLE",
      "SET_MENU_ACTIVE"
    ]),
    closeMenu() {
      this.SET_MENU_ACTIVE(false);
    }
  }
};
</script>

<style lang="scss">
.wrapper {
  display: flex;
  background-color: $color-bg;
  min-height: 100vh;
  max-width: 1500px;
  padding: 0 25px 60px;

  &__content {
    width: 100%;
    position: relative;

    &.is-loading {
      height: calc(100vh - 80px);
      overflow: hidden;
    }
  }
}

.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 999;
  max-width: 100vw;
  max-height: 100vh;
  width: 100%;
  @media (min-width: 769px) {
    display: none;
  }
  &.active-backdrop {
    opacity: 1;
    visibility: visible;
  }
}

.sidebar {
  background: #f6f7f8;
}

@media (max-width: 768px) {
  .wrapper.container {
    display: block;
    padding: 0 16px 16px;
  }

  .wrapper.container.is-fluid {
    padding: 0 16px 16px;
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: -10px;
    height: 100%;
    z-index: 1000;
    transform: translateX(-100%);
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
    padding: 30px 10px 0 10px;
    width: 220px;
  }

  .sidebar.active {
    transform: translateX(10px);
  }

  .backdrop.active {
    opacity: 1;
    visibility: visible;
  }

  .menu-btn,
  .close-btn {
    display: block;
  }

  .close-btn {
    color: white;
    margin-bottom: 20px;
  }
}
</style>
